module.exports = __webpack_public_path__ + "img/home_19.32a86cb0.png";